// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2dk77","newExpiryDate":"styles_newExpiryDate__1ye09","footer":"styles_footer__3v1Eu"};